<template>
  <div>
    <!--    <div style="float: left">-->
    <!--      <router-link to="/reportTools/cusMain" style="color: darkblue">-->
    <!--        返回客户管理页面-->
    <!--      </router-link>-->
    <!--    </div>-->
    <h1>自定义报表</h1>
    <div style="margin-right: -380px">
      <el-input
        v-model="searchreport"
        placeholder="可通过 报表名称 搜索"
        style="width:300px;margin-left:18px;margin-top:7px"
        class="filter-item"

      />
      <el-button v-model="searchreport" @click="searchData">搜索</el-button>
    </div>
    <div align="center">
    <el-table
      :data="tableData"
      :header-cell-style="{'text-align':'left'}"
      :cell-style="{'text-align':'left'}"
      style="width: auto;min-width: auto">
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="isPublic"
        label="公私有"
        width="180">
      </el-table-column>
      <el-table-column
        prop="reportName"
        label="报表名称"
        width="380">
      </el-table-column>
      <el-table-column
        label="查看" width="180">
<!--        <router-link to="previewReport" style="color: #525151;" @click="showTable">查看</router-link>-->
<!--        <el-button @click="showTable" >查看</el-button>-->
<!--        <a href="showtable?datasid=b6e09720-36d8-11eb-a546-8988d9df695d&lang=cn">查看</a>-->
        <template slot-scope="scope">
          <el-button @click="showTable(scope.row,scope.HOUURL)" type="primary" style="margin-left: 16px;">
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      size="99.99%"
      >
      <iframe :src="iframeURL" style="width: 100%;height: 100%;min-height: 700px"></iframe>
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    // const code = ''
    return {
      currentPage:1, //初始页
      pagesize:10,    //    每页的数据
      total:0, //总条数
      // userList: [],
      tableData: [],
      cusList:{},
      cusName:"",
      cusId:this.$route.params.cusId,
      searchreport:'',
      drawer: false,//查看的弹框
      iframeURL:'',
      HOUURLL:''
    }

  },
  created () {
    this.getdynamicList();
    let cusId = this.$route.params.cusId;
    console.log(cusId);
    console.log("url",window.location.origin)
    //this.getDataFromApi()
    //this.handleUserList()
  },
  methods: {

    //发送get请求
    showTable(row,HOUURL){
      let HOUHOUURL = this.HOUURL;
      console.log(HOUHOUURL)
      console.log(HOUHOUURL,row.code)
      this.drawer = true;
      this.iframeURL=HOUHOUURL+"showtable?datasid="+row.code+"&lang=cn";

    },
    tableData1(id){
      alert(id);
    },

    toCustomQuery(){
      // sessionStorage.setItem("cusId",cusId)
      this.$router.push({name:'/reportTools/customQuery',params:{cusId:cusId}});
    },
    indexMethod(index) {
      return index * 1;
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getdynamicList();
      console.log(this.pagesize)  //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
      this.getdynamicList();
      console.log(this.currentPage)  //点击第几页
    },
    // 搜索函数
    searchData(searchreport) {
      this.reportName = searchreport
      this.getdynamicList();
      console.log(searchreport)
    },
    //获取列表数据
    getdynamicList(){
      return [
        this.$http.get("/reporttools/sys-report-data/query",{
          params:{
            current:this.currentPage,//后台:前台
            size:this.pagesize,//后台:前台
            cusId:this.$route.params.cusId,
            reportName:this.searchreport,
          }
        }).then(resp =>{
          this.tableData = resp.data.records;//
           //console.log(resp.config.baseURL);
          this.HOUURL = resp.config.baseURL;
          //alert(resp.data.code)
          this.tableData.map(data => {
            data.isPublic==1?data.isPublic="公有":data.isPublic="私有";
            data.status==0?data.status="正常":(data.status==1?data.status="删除":data.status="停用")
          })
          this.total = resp.data.total;
          //console.log(data);

        })
      ]
    },
    getDataFromApi() {
      this.$http.get("/CusMain/query",{
      }).then(resp => {
          this.cusList = resp.data;//设置当前页数据
          console.log(resp);
        }

      )
    },

  }
};
</script>
<style>
a {
  text-decoration: none;
}
</style>





// WEBPACK FOOTER //
// src/components/reportTools/newReportList.vue